module.exports = __webpack_public_path__ + "static/media/nuts.f86b83a4.jpg";